import userProjectConfigModel from '$$userProjectConfigModel';

const sharedProjectsHelpers = {
  prepareInitProjects(obj) {
    obj.gantt_id = +obj.gantt_id;
    obj.id = obj.gantt_id;
    obj.skin = obj.userSkin || userProjectConfigModel.getUserSkinByGanttId(obj.id) || obj.skin;

    if (_.isString(obj.userConfig)) {
      obj.userConfig = JSON.parse(obj.userConfig);
    }

    if (_.isString(obj.config)) {
      obj.config = JSON.parse(obj.config);
    }

    if (obj.userSkin) {
      obj.config.userSkin = obj.userSkin;
    }

    obj.config.isJira = !!obj.is_jira;

    if (_.isUndefined(obj.config.show_advanced_buttons)) {
      obj.config.show_advanced_buttons = 1; // default
    }

    if (_.isUndefined(obj.config.show_resource_avatar)) {
      obj.config.show_resource_avatar = 1; // default
    }
    if (_.isUndefined(obj.config.discoloration_tasks)) {
      obj.config.discoloration_tasks = 1; // default
    }
    if (_.isUndefined(obj.config.cross_out_tasks)) {
      obj.config.cross_out_tasks = 1; // default
    }
    if (_.isUndefined(obj.config.right_side_text)) {
      obj.config.right_side_text = 'insideText'; // default
    }

    return obj;
  },

};

export default sharedProjectsHelpers;
